import { analyticsLib } from '../lib';
import type { AnalyticsEvent, AppAnalytics } from '../types';

export class DevAnalytics implements AppAnalytics {
  prefix: string;

  constructor(prefix = '') {
    this.prefix = prefix;
  }

  logEvent(originalEvent: AnalyticsEvent) {
    const prefixedEvent = analyticsLib.getPrefixedEvent(
      this.prefix,
      originalEvent,
    );
    // eslint-disable-next-line no-console
    console.info('[Dev Analytics]:', prefixedEvent);
  }
}
